import { FC, MouseEvent, useRef, useState } from "react";
import styles from "./image-zoom.module.css";
import { resizeImage } from "@commons-monorepo/index";

type ImageZoomProps = {
  image: string;
  alt?: string;
  disabledMobile?: boolean;
  className?: string;
  onChangeZoom?: (zoom: boolean) => void;
};

const ImageZoom: FC<ImageZoomProps> = ({ image, alt, disabledMobile, className, onChangeZoom }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const sourceRef = useRef<HTMLImageElement>(null);
  const targetRef = useRef<HTMLImageElement>(null);

  const [active, setActive] = useState(0);
  const [offset, setOffset] = useState({ left: 0, top: 0 });

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    setActive((value) => {
      const newValue = value ? 0 : 1;
      onChangeZoom && onChangeZoom(!!newValue);
      if (!!newValue) {
        setTimeout(() => {
          handleMouseMove(e);
        }, 10);
      }
      return newValue;
    });
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    if (sourceRef.current && targetRef.current && containerRef.current) {
      const targetRect = targetRef.current.getBoundingClientRect();
      const sourceRect = sourceRef.current.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      const left = Math.max(Math.min(e.pageX - sourceRect.left, sourceRect.width), 0);
      const top = Math.max(Math.min(e.pageY - sourceRect.top, sourceRect.height), 0);

      const areaX = containerRect.width - targetRect.width;
      const areaY = containerRect.height - targetRect.height;

      const xRatio = left * 100 / containerRect.width;
      const yRatio = top * 100 / containerRect.height;

      const offsetX = areaX * xRatio / 100;
      const offsetY = areaY * yRatio / 100;

      setOffset({
        left: offsetX,
        top: offsetY
      });
    }
  };

  return (
    <div
      ref={containerRef}
      className={`${styles.zoomContainer} ${disabledMobile ? styles.disabledMobile : ""} ${
      className || ""
      } image-zoom-container`}
      onMouseMove={handleMouseMove}>

      <img
        ref={sourceRef}
        className={styles.preview}
        src={resizeImage(image, 700, 700, 80)}
        alt={alt}
        onClick={handleClick} />

      <img
        ref={targetRef}
        className={`${styles.original} ${active ? styles.originalActive : ""}`}
        src={image}
        alt={alt}
        style={{
          left: offset.left,
          top: offset.top
        }}
        onClick={handleClick} />

    </div>);

};

export default ImageZoom;